export const ADD_LRP_CART  = 'ADD_LRP_CART'
export const REDUCE_LRP_CART  = 'REDUCE_LRP_CART'
export const EDIT_LRP_CART  = 'EDIT_LRP_CART'
export const REDUCE_LRP_NEWPROMOCODE  = 'REDUCE_LRP_NEWPROMOCODE'
export const CHOOSE_LRP_ADDRESS = 'CHOOSE_LRP_ADDRESS'
export const CLEAR_LRP_CART = 'CLEAR_LRP_CART'
export const SEL_DAY = 'SEL_DAY'
export const INIT_BUYLRP='INIT_BUYLRP'
export const SET_STEPINFO='SET_STEPINFO'
export const SET_UNSAVE='SET_UNSAVE'
export const SET_LRP_TOTAL='SET_LRP_TOTAL'
export const SET_LRPSKU='SET_LRPSKU'
export const REDUCEALL_LRP_CART='REDUCEALL_LRP_CART'
export const SET_LRPTCONFIG='SET_LRPTCONFIG'
export const SET_ISBUY='SET_ISBUY'
export const SET_EDIT='SET_EDIT'



